export type CatalogResourceRef = {
  id: string;
  resource_set_id?: string | null;
  name: string;
};

/** The catalog row whose id was written into the field, if the text is one. */
export function catalogResourceForInput(
  text: string,
  resources: readonly CatalogResourceRef[]
): CatalogResourceRef | undefined {
  const trimmed = text.trim();
  if (!trimmed) return undefined;
  return resources.find(
    (resource) =>
      resource.id === trimmed || resource.resource_set_id === trimmed
  );
}

/**
 * Combobox selection reports the item value, which is a catalog id. The field
 * should keep showing the resource name.
 */
export function resourceInputText(
  text: string,
  resources: readonly CatalogResourceRef[]
): string {
  return catalogResourceForInput(text, resources)?.name ?? text;
}
